// extracted by mini-css-extract-plugin
export default {"btnSubmit":"FormContact_btnSubmit__7Kj6Q"};